import React, { useEffect } from 'react';

export default function CustomAlert({ open, message, type = 'info', onClose, title }) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  if (!open) return null;

  const getIcon = () => {
    switch (type) {
      case 'success': return '✅';
      case 'error': return '❌';
      case 'warning': return '⚠️';
      default: return 'ℹ️';
    }
  };

  const getTitle = () => {
    if (title) return title;
    switch (type) {
      case 'success': return '成功';
      case 'error': return '错误';
      case 'warning': return '警告';
      default: return '提示';
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      backdropFilter: 'blur(4px)',
      overflow: 'hidden' // 防止滚动
    }}>
      <div style={{
        background: '#fff',
        borderRadius: '12px',
        padding: '32px 28px 24px 28px',
        maxWidth: '340px',
        width: '90%',
        maxHeight: '90vh', // 限制弹窗最大高度
        overflowY: 'auto', // 弹窗内容超出时内部滚动
        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
        textAlign: 'center',
        animation: 'slideIn 0.3s ease-out'
      }}>
        <div style={{
          fontSize: '36px',
          marginBottom: '12px'
        }}>
          {getIcon()}
        </div>
        <h3 style={{
          margin: '0 0 10px 0',
          color: '#333',
          fontSize: '20px',
          fontWeight: '600'
        }}>
          {getTitle()}
        </h3>
        <div style={{
          color: '#666',
          lineHeight: '1.7',
          marginBottom: '24px',
          fontSize: '15px'
        }}>
          {message}
        </div>
        <button
          onClick={onClose}
          style={{
            background: 'var(--primary-color)',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            padding: '10px 32px',
            fontSize: '16px',
            cursor: 'pointer',
            fontWeight: '500'
          }}
        >
          确定
        </button>
      </div>
      <style>{`
        @keyframes slideIn {
          from { opacity: 0; transform: translateY(-20px) scale(0.95);}
          to { opacity: 1; transform: translateY(0) scale(1);}
        }
      `}</style>
    </div>
  );
}